<template>
  <div class="animated fadeIn" id="Form-survey">
    <div class="card">
      <div class="card-header text-center">{{mData.dataForm.survey.name}}</div>
      <div class="card-body text-center">
        {{mData.dataForm.survey.description}}
        <!-- {{mData.dataFormRender}} - {{mData.validFormRender}} -->
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <el-form
          :model="mData.dataFormRender"
          :rules="mData.validFormRender"
          ref="myForm"
          class="w-100"
          label-width="50%"
          label-position="top"
        >
          <b-row
            v-for="item in mData.dataForm.surveyItems"
            :key="item.code"
            class="justify-content-center"
          >
            <b-col md="5" v-if="item.inputControl === 'number'">
              <el-form-item :label="item.title" :prop="item.code">
                <el-input-number
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="mData.dataDefault.viewMode == 'detail'"
                ></el-input-number>
              </el-form-item>
            </b-col>
            <b-col md="5" v-if="item.inputControl === 'textbox' || item.inputControl === 'email' ">
              <el-form-item :label="item.title" :prop="item.code">
                <el-input
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="mData.dataDefault.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <!-- <b-col md="5" v-if="item.inputControl === 'hidden'">
              <el-form-item label="">
                <el-input
                  type="hidden"
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="mData.dataDefault.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>-->
            <b-col md="5" v-if="item.inputControl === 'date'">
              <el-form-item :label="item.title" :prop="item.code">
                <el-date-picker
                  type="date"
                  :format="aElement.datepicker.formatDate"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormRender[item.code]"
                  :placeholder="aElement.datepicker.placeholderDate"
                  clearable
                  :disabled="mData.dataDefault.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="5" v-if="item.inputControl === 'datetime'">
              <el-form-item :label="item.title" :prop="item.code">
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormRender[item.code]"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.dataDefault.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="5" v-if="item.inputControl === 'selectbox'">
              <el-form-item :label="item.title" :prop="item.code">
                <el-select
                  :multiple="item.isMultipleValue"
                  v-model="mData.dataFormRender[item.code]"
                  placeholder="Select"
                  :disabled="mData.dataDefault.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item1 in mData.dataDefault.optionSelectBox[item.code]"
                    :key="item1.key"
                    :label="item1.value"
                    :value="item1.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="5" v-if="item.inputControl === 'radio'">
              <el-form-item :label="item.title" :prop="item.code">
                <el-radio-group
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="mData.dataDefault.viewMode == 'detail'"
                >
                  <el-radio
                    class="mr-5"
                    v-for="item1 in mData.dataDefault.optionRadio[item.code]"
                    :key="item1.key"
                    :label="item1.value"
                    :value="item.value"
                  ></el-radio>
                </el-radio-group>
              </el-form-item>
            </b-col>
            <b-col md="5" v-if="item.inputControl === 'checkbox'">
              <el-form-item :label="item.title" :prop="item.code">
                <el-select
                  multiple
                  v-model="mData.dataFormRender[item.code]"
                  placeholder="Chọn"
                  :disabled="mData.dataDefault.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item1 in mData.dataDefault.optionCheckBox[item.code]"
                    :key="item1.key"
                    :label="item1.value"
                    :value="item1.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="5" v-if="item.inputControl === 'label'">
              <el-form-item :label="item.title"></el-form-item>
            </b-col>
          </b-row>
          <b-row
            class="justify-content-center mb-3 mt-3"
            v-if="mData.dataDefault.viewMode == 'create' || mData.dataDefault.viewMode == 'update'"
          >
            <b-col md="3">
              <el-button
                type="success"
                class="btn-block"
                v-ladda
                @click="fn_submitForm"
              >Gửi thông tin khai báo</el-button>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import SurveyModel from "./SurveyModel";
import SurveyApi from "../../../moduleApi/SurveyApi";
import SurveyItemApi from "../../../moduleApi/SurveyItemApi";
import ValidService from "../../../service/ValidService";
import SurveyResultApi from "../../../moduleApi/SurveyResultApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        dataDefault: {
          optionSelectBox: {},
          optionCheckBox: {},
          optionRadio: {},
          dataParams: {},
          prefillData: {},
          viewMode: "create"
        },
        dataForm: MethodService.copyObject(SurveyModel.dataForm),
        validForm: MethodService.copyObject(SurveyModel.validForm),

        dataFormRender: {},
        validFormRender: {}
      }
    };
  },
  methods: {
    async fn_initDataForm(resultParam) {
      let surveyId = resultParam.surveyId;

      let req_Survey = SurveyApi.findById(surveyId);
      let req_SurveyItem = SurveyItemApi.list({
        filters: "surveyId=" + surveyId
      });

      let res_Survey = await req_Survey;
      let res_SurveyItem = await req_SurveyItem;

      this.mData.dataForm.survey = res_Survey.result ? res_Survey.result : {};
      this.mData.dataForm.surveyItems = res_SurveyItem.result
        ? res_SurveyItem.result
        : [];

      console.log(this.mData.dataForm.surveyItems);

      let optionSelectBox = {};
      let optionCheckBox = {};
      let optionRadio = {};
      let dataFormRender = {};
      let validFormRender = {};

      this.mData.dataForm.surveyItems.map(item => {
        dataFormRender[item.code] = null;
        validFormRender[item.code] = [];

        //set dataDefault
        if (item.inputControl === "selectbox") {
          let arrSplit = JSON.parse(item.dataSource.value);
          for (let key in arrSplit) {
            arrSplit[key] = arrSplit[key].trim();
          };
          optionSelectBox[item.code] = this.fn_convertJsonToKeyValueOption(arrSplit);
        }

        if (item.inputControl === "checkbox") {
          let arrSplit = JSON.parse(item.dataSource.value);
          for (let key in arrSplit) {
            arrSplit[key] = arrSplit[key].trim();
          };
          optionCheckBox[item.code] = this.fn_convertJsonToKeyValueOption(arrSplit);
        }

        if (item.inputControl === "radio") {
          let arrSplit = JSON.parse(item.dataSource.value);
          for (let key in arrSplit) {
            arrSplit[key] = arrSplit[key].trim();
          };
          optionRadio[item.code] = this.fn_convertJsonToKeyValueOption(arrSplit);
        }

        // set validDefault
        if (item.validation.required) {
          validFormRender[item.code].push(ValidService.required);
        }
        if (
          item.validation.length > 0 ||
          item.validation.minLength > 0 ||
          item.validation.maxLength > 0
        ) {
          validFormRender[item.code].push(
            ValidService.checkLength(
              item.validation.minLength ? item.validation.minLength : null,
              item.validation.maxLength ? item.validation.maxLength : null
            )
          );
        }

        if (item.validation.pattern) {
          validFormRender[item.code].push(
            ValidService.checkPattern(
              item.validation.pattern,
              item.validation.patternMessage
            )
          );
        }

        if (item.inputControl === "email") {
          validFormRender[item.code].push(ValidService.checkEmail);
        }
      });

      this.mData.dataDefault.optionSelectBox = optionSelectBox;
      this.mData.dataDefault.optionCheckBox = optionCheckBox;
      this.mData.dataDefault.optionRadio = optionRadio;
      this.mData.dataFormRender = dataFormRender;
      this.mData.validFormRender = validFormRender;
    },

    fn_submitForm() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let result = this.fn_getSurveyResults();

          if (this.mData.dataDefault.viewMode == "create") {
            let formData = {
              surveyId: this.mData.dataForm.survey.id,
              result: result,
              callbackUrl: this.mData.dataDefault.dataParams.callbackUrl,
              appCode: this.mData.dataDefault.dataParams.appCode
              // objectReferenceId: this.mData.dataDefault.prefillData.objectId
            };

            let res = await SurveyResultApi.create(
              formData,
              this.mData.dataDefault.dataParams
            );
            if (res.result) {
              this.$router.push({
                name: "Client-Survey-Result-Successful"
              });
            }
            // this.fn_resetForm();
            // MethodService.stopLadda();
          }
          if (this.mData.dataDefault.viewMode == "update") {
            let formData = {
              surveyId: this.mData.dataForm.survey.id,
              result: result,
              callbackUrl: this.mData.dataDefault.dataParams.callbackUrl,
              appCode: this.mData.dataDefault.dataParams.appCode
              // objectReferenceId: this.mData.dataDefault.prefillData.objectId
            };
            let params = MethodService.copyObject(
              this.mData.dataDefault.dataParams
            );
            params.surveyToken = this.mData.dataDefault.prefillData.surveyToken;

            let res = await SurveyResultApi.update(formData, params);

            if (res.result) {
              this.$router.push({
                name: "Client-Survey-Result-Successful"
              });
            }
          }
        } else {
          toastr.warning("Một số trường nhập chưa đúng hoặc còn thiếu!");
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },

    fn_getSurveyResults() {
      let dataFormRender = MethodService.copyObject(this.mData.dataFormRender);
      let keyItems = Object.keys(dataFormRender);
      let surveyResult = [];

      keyItems.map(item => {
        let value = dataFormRender[item];
        if (MethodService.isUndefined(value) || MethodService.isNull(value)) {
          value = "";
        }
        if (MethodService.isString(value)) {
          value = value.trim();
        }
        if (MethodService.isArray(value)) {
          if (value.length > 1) {
            value = value.join("\n");
          } else {
            value = value.toString();
          }
        }
        let obj = {
          code: item,
          value: value
        };
        surveyResult.push(obj);
      });

      return surveyResult;
    },
    fn_convertArrayToString(value) {
      if (value == null || value === "undefined") return "";
      return value.join();
    },
    fn_isArrayOrUndefined(value) {
      return MethodService.isArray(value) || MethodService.isUndefined(value);
    },

    fn_setValueFromPrefillData(resultParam) {
      let dataFormRender = MethodService.copyObject(this.mData.dataFormRender);
      for (let item in resultParam) {
        let val = resultParam[item];
        dataFormRender[item] = val;
      }

      this.mData.dataForm.surveyItems.forEach(element => {
        if (element.inputControl == "checkbox") {
          if (resultParam[element.code]) {
            dataFormRender[element.code] = resultParam[element.code].split(
              "\n"
            );
          }
        }
      });
      console.log(dataFormRender);
      this.mData.dataFormRender = dataFormRender;
    },
    fn_convertJsonToKeyValueOption(json) {
      let valueOption =[];
      for (let key in json) {
        valueOption.push({
          key: key,
          value: json[key]
        })
      }
      return valueOption;
    },
  },

  created: async function() {
    let query = MethodService.copyObject(this.$router.currentRoute.query);
    this.mData.dataDefault.dataParams = query;
    this.mData.dataDefault.viewMode = query.viewMode;
    console.log(this.mData.dataDefault.dataParams);

    if (this.$router.currentRoute.query.prefillData) {
      let resultParam = MethodService.decode(
        this.$router.currentRoute.query.prefillData
      );
      console.log('resultParam decode', resultParam);
      resultParam = JSON.parse(resultParam);
      console.log(resultParam);
      this.mData.dataDefault.prefillData = resultParam;
      if (resultParam && resultParam.surveyId) {
        await this.fn_initDataForm(resultParam);

        this.fn_setValueFromPrefillData(resultParam);
      } else {
        toastr.error("Lỗi dữ liệu đầu vào");
      }
    }
  }
};
</script>

<style scoped>
</style>
